module.exports = __webpack_public_path__ + "static/media/previewbannera.ee3f8560.svg";